export const ROUTE_PATH_WIKI = "/wiki";
